jQuery(document).ready(function () {
  jQuery(".new_addition_card video.product_video").attr("autoplay", " ");
  jQuery(".buynow_btnb a.theme_btn").attr("target", "_blank");

 setTimeout(function(){
         jQuery('div#singupmodal').modal('show'); 
   }, 2000);

  
});

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});



jQuery('#singupmodal,#videomodal').on('show.bs.modal', function() {
   var jQueryscrollElement = jQuery('<div>').css({
     width: '100px',
     height: '100px',
     overflow: 'scroll',
     visibility: 'hidden'
   }).appendTo('body');
   var scrollbarWidth = jQueryscrollElement[0].offsetWidth - jQueryscrollElement[0].clientWidth;
   jQueryscrollElement.remove();
   jQuery('header').css('padding-right',scrollbarWidth);
});



jQuery('#singupmodal,#videomodal').on('hidden.bs.modal', function() {
   jQuery('header').css('padding-right','0');
});